import React from "react";

import { useTranslation } from "react-i18next";
import { colors } from "../../../styles/variables";
import { I18N_NAMESPACES } from "../../../helpers/constants";
import StyledSideTray from "../SideTray/StyledSideTray";
import { ChallengeBadges_memberBadgesByCategory } from "../../../types/__generated__/ChallengeBadges";
import {
  BackArrow,
  Header,
  ChallengeDescriptionTitle,
  ChallengeDescriptionWrapper,
  ChallengeGameplayTitle,
} from "./style";

interface ChallengeGameplayProps {
  challenge: ChallengeBadges_memberBadgesByCategory | null | undefined;
  onClose: Function;
  isInBoxAndCartTray?: boolean;
}

const ChallengeGameplay = ({ challenge, onClose, isInBoxAndCartTray }: ChallengeGameplayProps) => {
  const { t } = useTranslation([I18N_NAMESPACES.MY_BADGES]);

  return (
    <StyledSideTray
      isOpened={!!challenge?.challengeGameplayTitle1}
      color={colors.white}
      shouldAnimate
      onClickBackdrop={() => onClose()}
      isInBoxAndCartTray={isInBoxAndCartTray}
    >
      <Header>
        <BackArrow onClick={() => onClose()} />
        <ChallengeDescriptionTitle>{t("myBadges:gameplay")}</ChallengeDescriptionTitle>
      </Header>
      <ChallengeDescriptionWrapper>
        <ChallengeGameplayTitle>{challenge?.challengeGameplayTitle1 ?? ""}</ChallengeGameplayTitle>
        <p>{challenge?.challengeGameplayDescription1 ?? ""}</p>
        <ChallengeGameplayTitle>{challenge?.challengeGameplayTitle2 ?? ""}</ChallengeGameplayTitle>
        <p>{challenge?.challengeGameplayDescription2 ?? ""}</p>
        <ChallengeGameplayTitle>{challenge?.challengeGameplayTitle3 ?? ""}</ChallengeGameplayTitle>
        <p>{challenge?.challengeGameplayDescription3 ?? ""}</p>
      </ChallengeDescriptionWrapper>
    </StyledSideTray>
  );
};

ChallengeGameplay.defaultOptions = {
  isInBoxAndCartTray: false,
};

export default ChallengeGameplay;
